import React, { Component } from "react";
import { View, StyleSheet, Platform, TouchableHighlight } from "react-native";
import Text from "../../components_v2/TextFont";
import { ArButton } from "../../argon-ui";
import SimpleTimePicker from "../../components_v2/SimpleTimePicker";
import { translate } from "../../locales/translate";
import FontAwesomeIcon from "../../components_v2/FontAwesomeIcon";
import { faTrash } from "../../../assets/consts/faCharCodes";
import Theme from "../../argon-ui/Theme";

class OptionalConditionTimeRange extends Component {
  constructor(props) {
    super(props);
    let { id, from, to } = this.props;
    this.state = {
      id,
      from,
      to,
    };
  }

  componentDidMount() {}

  handleOnFromChanged = (time) => {
    this.setState({ from: time }, () => {
      this.props.onFromChanged && this.props.onFromChanged(time);
    });
  };

  handleOnToChanged = (time) => {
    this.setState({ to: time }, () => {
      this.props.onToChanged && this.props.onToChanged(time);
    });
  };

  handleOnDelete = () => {
    this.props.onDelete && this.props.onDelete(this.state.id);
  };

  render() {
    return (
      <View style={styles.container}>
        <View style={{ flexDirection: "row", alignItems: "center", flex: 1 }}>
          <Text style={{ fontWeight: "bold", paddingHorizontal: 5 }}>
            {translate("scenario.timeFrom")}
          </Text>
          <SimpleTimePicker
            value={this.state.from}
            onChange={this.handleOnFromChanged}
          />
        </View>
        <View style={{ flexDirection: "row", alignItems: "center", flex: 1 }}>
          <Text style={{ fontWeight: "bold", paddingHorizontal: 5 }}>
            {translate("scenario.timeTo")}
          </Text>
          <SimpleTimePicker
            value={this.state.to}
            // fontSize={11}
            onChange={this.handleOnToChanged}
          />
        </View>
        <TouchableHighlight
          underlayColor="transparent"
          style={{
            width: 35,
            height: 35,
            backgroundColor: Theme.COLORS.ERROR,
            justifyContent: "center",
            alignItems: "center",
            borderRadius: 5,
            marginHorizontal: 5,
          }}
          onPress={this.handleOnDelete}
        >
          <FontAwesomeIcon icon={faTrash} color="#FFF" size={16} />
        </TouchableHighlight>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginVertical: 5,
    padding: 3,
    paddingEnd: 5,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: "#FB634030",
    backgroundColor: "#FB634010",
  },
});

export default OptionalConditionTimeRange;
